package com.zi.support.web

import kotlinx.browser.document
import kotlinx.browser.window

/** Native apps reuse the reporting surface, including all filters, charts, tables and PDF exports. */
internal object MobileInsights {
    val kind: String = (js("new URLSearchParams(window.location.search).get('mobileInsights')") as? String)
        ?.takeIf { it in listOf("tickets", "issues", "calls") }.orEmpty()
    val enabled get() = kind.isNotBlank()
    private var initialFilters: dynamic = null
    fun filter(key: String): String {
        if (!enabled || initialFilters == null) return ""
        return initialFilters[key] as? String ?: ""
    }
    fun applyInputs() {
        if (!enabled) return
        element(if (kind == "tickets") "ticket-search" else "issue-search")?.asDynamic()?.value = filter("search")
        if (kind == "tickets") {
            val selected = filter("statuses").split("|").map { when (it) {
                "My tickets" -> "mine"; "Unassigned" -> "open"; "Assigned & in progress" -> "in_progress"; "Completed" -> "completed"; else -> "all"
            } }
            val nodes = document.querySelectorAll("[data-ticket-status]")
            for (i in 0 until nodes.length) (nodes.item(i) as org.w3c.dom.Element).let { it.classList.toggle("active", it.getAttribute("data-ticket-status") in selected) }
            val mine = document.querySelectorAll("[data-my-ticket-status]")
            val mineStatus = filter("mineStatus").ifBlank { "all" }
            for (i in 0 until mine.length) (mine.item(i) as org.w3c.dom.Element).let { it.classList.toggle("active", it.getAttribute("data-my-ticket-status") == mineStatus) }
        }
    }

    fun install() {
        if (!enabled) return
        document.documentElement?.classList?.add("mobile-insights")
        // The app preloads this page hidden and shows it once signed in, so the boot splash never needs to show.
        document.getElementById("boot-splash")?.remove()
        // The host injects a freshly minted token in memory after verifying this page's origin.
        // No credentials appear in a URL, history, localStorage or on a JS bridge.
        window.asDynamic().supportMobileSignIn = { token: String, filters: dynamic ->
            initialFilters = filters
            FirebaseGateway.loginEphemeral(token)
        }
        // Tapping Insights in the app sends the list's current filters; the page redraws with them.
        window.asDynamic().supportMobileFilters = { filters: dynamic -> initialFilters = filters; WebApp.navigate(kind) }
    }
    fun waiting() {
        element("app")?.innerHTML = "<main class=\"boot\"><div class=\"spinner\"></div><p>Opening insights…</p></main>"
    }
    fun post(value: dynamic) {
        val encoded = JSON.stringify(value)
        val w = window.asDynamic()
        if (w.NativeInsights != null) w.NativeInsights.postMessage(encoded)
        else if (w.webkit?.messageHandlers?.mobileInsights != null) w.webkit.messageHandlers.mobileInsights.postMessage(encoded)
    }
}
